import React from "react";
import { ExternalLink } from "lucide-react";
import { useQuote } from "../QuoteDialog";

export default function BundlesCTA() {
  const { openQuote } = useQuote();

  return (
    <section
      data-testid="bundles-cta-section"
      className="relative bg-navy text-white py-24 md:py-32 overflow-hidden"
    >
      <div
        aria-hidden
        className="absolute inset-0 opacity-[0.06]"
        style={{
          backgroundImage:
            "linear-gradient(#fff 1px, transparent 1px), linear-gradient(90deg, #fff 1px, transparent 1px)",
          backgroundSize: "64px 64px",
        }}
      />
      <div className="absolute -bottom-32 -right-32 w-96 h-96 bg-teal/20 rounded-full blur-3xl" />

      <div className="relative max-w-5xl mx-auto px-6 md:px-12 lg:px-16 text-center">
        <div className="cmyk-ribbon h-1 w-24 mx-auto mb-10 rounded-full" aria-hidden />
        <h2
          data-testid="bundles-cta-headline"
          className="font-serif text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-black tracking-tight text-white leading-[1.1]"
        >
          Get a Complete System{" "}
          <span className="text-teal">for Your School.</span>
        </h2>
        <p className="mt-8 text-lg sm:text-xl text-slate-300 leading-relaxed max-w-2xl mx-auto">
          We'll recommend the right bundle based on your needs, size, and usage.
        </p>
        <div className="mt-10 flex items-center justify-center">
          <button
            data-testid="bundles-cta-quote-btn"
            onClick={openQuote}
            title="Opens in a new tab"
            className="group inline-flex items-center justify-center gap-2 bg-teal hover:bg-[#0D6BB1] text-white font-bold px-8 py-4 rounded-lg shadow-xl hover:shadow-2xl transition-all duration-200 hover:-translate-y-0.5"
          >
            Request a Quote
            <ExternalLink className="w-5 h-5 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </button>
        </div>
      </div>
    </section>
  );
}
